module.exports = __webpack_public_path__ + "static/media/phone.34a07198.svg";